import { useEffect, useRef, useState } from 'react';
import Name from './Name';
import Questions from './Questions';
import Result from './Result';
import styles from './styles.module.scss';
import duelStyles from '../styles.module.scss';
import Modal from 'app/components/Modal';
import QuestionCountdown from './QuestionCountdown';
import { useWeeklyChallenge } from 'app/hooks/useWeeklyChallenge';

export default function PlayerModal({ duel, setOpenPlayerModal, setNewDuelModal, openPlayerModal, winner, getWinner, setWinner, onCloseRefresh }) {
  const questionCountdownRef = useRef();

  const { setCurrentStep, setStart, currentStep, setShowQuestionCountDown, showQuestionCountDown, taxonomies, setQuestionCountDownTimer, setGeneralCount, setChallengeType } = useWeeklyChallenge();

  const handleCloseModal = () => {
    setGeneralCount(0);
    setOpenPlayerModal(false);
    setStart(false);
    setShowQuestionCountDown(false);
    setQuestionCountDownTimer(5);
    setWinner(null);
    onCloseRefresh?.();
    setChallengeType(null);
  };

  useEffect(() => {
    if (openPlayerModal && currentStep === 1) {
      questionCountdownRef.current = setTimeout(() => {
        setShowQuestionCountDown(true);
      }, 6000);
    }
    return () => {
      if (questionCountdownRef.current) {
        clearTimeout(questionCountdownRef.current);
      }
    };
  }, [openPlayerModal, taxonomies]);

  return (
    <Modal
      show={openPlayerModal}
      onClose={handleCloseModal}
      contentClassName={`modal__content--lg u-pl-0 u-pr-0 ${duelStyles['duel-modal']}`}
    >
      <div className={styles['player-modal']}>
        {currentStep === 1 && <Name duel={duel} />}
        {currentStep === 2 && <Questions />}
        {currentStep === 3 && (
          <Result
            setNewDuelModal={setNewDuelModal}
            winner={winner}
            getWinner={getWinner}
            handleCloseModal={handleCloseModal}
          />
        )}
      </div>
      <QuestionCountdown
        showQuestionCountDown={showQuestionCountDown}
        setShowQuestionCountDown={setShowQuestionCountDown}
      />
    </Modal>
  );
}
